<template>
    <div></div>
</template>
<script>

    export default {
        props: ['value','isModal'],
        data () {
            return {
                /*
                config: {
                    events: {
                        'froalaEditor.initialized': function () {
                            console.log('initialized')
                        }
                    },
                    toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'fontFamily', 'fontSize', '|', 'paragraphStyle', 'paragraphFormat', 'align', 'undo', 'redo', 'html']
                },
                */
                className:"modal-fade-enter-active",
                resource: {},
                locale: null,
                locales: null,
                localesLoaded: null
            }
        },
        created: function() {
        },
        mounted: function(){
            this.locale = this.$store.state.scope.locales[0].id
            this.locales = this.$store.state.scope.locales

            if( this.value && this.isModal )
            {
                this.resource = this.value;
            }

            self = this;
            document.onkeydown=function(event){
                if((event.ctrlKey || event.metaKey) && event.which == 83) {
                    event.preventDefault();
                    self.submit()
                    return false;
                }
            }

            self = this
            setTimeout(function(){
                self.resourceLoaded();
            }, 50);
        },
        methods:{
            copy:function(original) {
                return JSON.parse(JSON.stringify(original));
            },
            setTranslations: function(fields){
                //if( this.resource.translations ){
                    let translations = {};
                    for (var i=0 ; i<this.locales.length ; i++ ) {
                        let locale = this.locales[i];
                        translations[locale.id] = {};
                        let founded = false;
                        if( this.resource.translations ) {
                            for (var a = 0; a < this.resource.translations.length; a++) {
                                let item = this.resource.translations[a];
                                if (item.locale == locale.id) {
                                    for (var x = 0; x < fields.length; x++) {
                                        translations[locale.id][fields[x]] = item[fields[x]];
                                    }
                                    founded = true;
                                }
                            }
                        }
                        if( !founded ){
                            for (var x=0 ; x<fields.length ; x++ ) {
                                translations[locale.id][fields[x]] = "";
                            }
                        }
                    }
                    this.resource.translations = translations;
                //}
                this.localesLoaded = true;
            },
            resourceLoaded: function(){
                self.initialize();
            },
            beforeUpdate: function(Resource){
                return true;
            },
            submit: function(){

                let self = this;
                let Resource = Object.assign({}, this.resource);

                if( !this.beforeUpdate(Resource) ){
                    return false;
                }

                this.getResource().create(Resource).then((response) => {

                    if( self.isModal )
                    {
                        self.$emit('validate', response.data);
                    }else{
                        self.$emit('refresh', this);
                        self.back(response.data.id);
                    }
                })

            },
            back: function(id){
                self = this
                if( this.className == "" && !this.isModal ){
                    if( id )
                    {
                        self.$router.push({name: self.getResource().resource + "-edit", params: {id: id}});
                    }else{
                        self.$router.push({name: self.getResource().resource});
                    }
                }
                self.$emit('close');
            },
            initialize: function(){
                var self = this;
                setTimeout(function(){self.className = ""}, 100)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/layouts/Create.vue